import i18next from 'i18next';

export default function validatePassword(password: string) {
  const value = password;
  let message = '';

  if (/[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(value)) {
    message = i18next.t('certPassword-koreanError');
  } else if (!value || value.length < 4 || value.length > 20) {
    message = i18next.t('certPassword-lengthError');
  }

  return message;
}
